<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/disclaimer">Disclaimer and Warning</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc"><a href="#/frontpage">How to Tell if Your School Is Haunted</a></p>
<p class="toc"><a href="#/frontpage1">What to Do if Your School Is Haunted</a></p>
<p class="toc1"><a href="#/chapter01">Anna Maria College</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Babson College</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Berklee College of Music</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Boston College</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Boston University</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Bridgewater State University</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Charlesgate Hall</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Emerson College</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Emmanuel College</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Endicott College</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Framingham State University</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Harvard University</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Lesley University</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">Mount Holyoke College</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">Northern Essex Community College</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">Pine Manor College</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">Regis College</span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">Salem State University</span></p>
<p class="toc"><span href="#/chapter19" title="Link target outside of Sample">Smith College</span></p>
<p class="toc"><span href="#/chapter20" title="Link target outside of Sample">Springfield College</span></p>
<p class="toc"><span href="#/chapter21" title="Link target outside of Sample">Stonehill College</span></p>
<p class="toc"><span href="#/chapter22" title="Link target outside of Sample">University of Massachusetts–Lowell (Chelmsford)</span></p>
<p class="toc"><span href="#/chapter23" title="Link target outside of Sample">University of Massachusetts–Lowell (Lowell)</span></p>
<p class="toc"><span href="#/chapter24" title="Link target outside of Sample">Wellesley College</span></p>
<p class="toc"><span href="#/chapter25" title="Link target outside of Sample">Western New England University</span></p>
<p class="toc"><span href="#/chapter26" title="Link target outside of Sample">Westfield State University</span></p>
<p class="toc"><span href="#/chapter27" title="Link target outside of Sample">Wheaton College</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?412f6ce1